// Noop: trigger frontend rebuild for deployment
import React from 'react';
import ReactDOM from 'react-dom/client';
import {App} from './matic/App';

// Import fonts from @fontsource (self-hosted, optimized)
// Load specific weights to match Next.js configuration
// Space Grotesk - primary font (weights: 300, 400, 500, 600, 700)
import '@fontsource/space-grotesk/300.css';
import '@fontsource/space-grotesk/400.css';
import '@fontsource/space-grotesk/500.css';
import '@fontsource/space-grotesk/600.css';
import '@fontsource/space-grotesk/700.css';

// Inter - secondary font (weights: 400, 500, 600, 700)
import '@fontsource/inter/400.css';
import '@fontsource/inter/500.css';
import '@fontsource/inter/600.css';
import '@fontsource/inter/700.css';

import './matic/styles/globals.css';
import {hideAppLoader} from './matic/lib/utils/hide-app-loader';

// Safety net: if React fails to boot or RootLayout never mounts, force-hide
// the persistent #app-loader overlay after 10s so the user is never trapped.
setTimeout(hideAppLoader, 10_000);

// The browser's back-forward cache (bfcache) restores the page DOM without
// re-mounting React, so the `<HideAppLoader />` mount effect doesn't fire on
// back-button / trackpad-swipe navigation — a still-visible #app-loader would
// be stuck. Hide it on bfcache restore (`event.persisted`) only. We must NOT
// hide it on a fresh load: that's exactly when the overlay needs to keep
// covering the screen while React boots and OIDC processes the sign-in
// callback; React dismisses it via `<HideAppLoader />` once the destination
// page is ready.
globalThis.addEventListener('pageshow', (event) => {
  if (event.persisted) {
    hideAppLoader();
  }
});

const root = document.querySelector('#root');

if (!root) {
  throw new Error('Root element not found');
}

ReactDOM.createRoot(root).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
